module.exports = __webpack_public_path__ + "img/pr.b013635d.svg";